import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("mcu_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatIDR(value) {
    const n = Number(value) || 0;
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
    }).format(n);
}

export function formatNumber(value) {
    const n = Number(value) || 0;
    return new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(n);
}

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Terjadi kesalahan";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (d && typeof d.msg === "string") return d.msg;
    return String(d);
}
